<div class="card card-custom instance-setting-sidebar">
    <div class="card-body pt-10 accordian-section new-accordian-scroll">
        <h3 class="heading_text">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.INSTANCE_CONFIGURATION_TAB.TITTLE' | transloco }}</h3>

        <!-- Parent -->
        <div *ngFor="let item of allowedItem?.allowedItemTypes" id="{{ item.allowedItemTypeId }}">
            <div class="plant-section">
                <div
                    class="child_section"
                    style="cursor: pointer"
                    (click)="itemSelected(item)"
                    [class.toggled]="item?.allowedItemTypeId == FirstChild?.allowedItemTypeId"
                >
                    <p>
                        <a>{{ item.name }}</a>
                    </p>
                </div>
            </div>
        </div>

        <hr />

        <app-instance-conf-sidebar-data
            *ngIf="FirstChild?.items"
            [items]="FirstChild"
            [level]="1"
            (selectedItemlevel)="selectedItemlevelHandler($event)"
        ></app-instance-conf-sidebar-data>

        <app-instance-conf-sidebar-data
            *ngIf="Secondchild?.items"
            [items]="Secondchild"
            [level]="2"
            (selectedItemlevel)="selectedItemlevelHandler($event)"
        ></app-instance-conf-sidebar-data>

        <app-instance-conf-sidebar-data
            *ngIf="Thirdchild?.items"
            [items]="Thirdchild"
            [level]="3"
            (selectedItemlevel)="selectedItemlevelHandler($event)"
        ></app-instance-conf-sidebar-data>
    </div>
</div>
